var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"custom-class":"theme-dialog split-line-footer-dialog no-padding-top-dialog","title":"人工录入问卷","visible":_vm.visibility,"width":"981px","append-to-body":""},on:{"update:visible":function($event){_vm.visibility=$event}}},[_c('EntrustInputSurvey',{attrs:{"isDialog":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }